import { render, staticRenderFns } from "./NavTopItems.vue?vue&type=template&id=5071f0d4&scoped=true"
import script from "./NavTopItems.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavTopItems.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NavTopItems.vue?vue&type=style&index=0&id=5071f0d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5071f0d4",
  null
  
)

export default component.exports